import styles from './Container.module.scss'
import cn from 'classnames'

type ContainerProps = {
  className?: string
  children: React.ReactNode
}

export default function Container({ className, children }: ContainerProps) {
  return (
    <div
      className={cn({
        [styles.container]: true,
        ...(className && { [className]: true }),
      })}
    >
      {children}
    </div>
  )
}
